import React, { Component } from "react";

import classes from "./Loading.module.scss";

class Loading extends Component {
  render() {
    return this.props.loading ? (
      <div className={classes.loadWrapper}>
        <div className={classes.innerWrapper}>
          <div className={classes.loader}></div>
          <div className={classes.loaderLabel}>{this.props.label}</div>
        </div>
      </div>
    ) : null;
  }
}

export default Loading;
